<ng-container *transloco="let t; read: 'configuration'">
<div class="rounded-lg fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ !editData ? t('sites.addNew') : t('sites.editTitle') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>
  <div mat-dialog-content>
    <form class="grid grid-cols-2 gap-x-10" [formGroup]="siteForm">

      @if (hasFullOptions) {
        <div class="input-container col-span-full md:col-span-1 z-50">
          <drdp-select-state (state)="onDropDownSelect($event, select.States)" [clear]="clearDropdowns"
            [initialStateId]="state.value">
          </drdp-select-state>
        </div>
      }

      @if (hasFullOptions) {
        <div class="input-container col-span-full md:col-span-1 z-50">
          <drdp-select-agency (agency)="onDropDownSelect($event, select.Agencies)" [stateId]="state.value"
            [initialAgencyId]="adminAgencyDropdown.value" [clear]="clearDropdowns">
          </drdp-select-agency>
        </div>
      }

      <div class="col-span-full">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="font-normal" for="SiteName">{{ t('sites.fields.siteName') }} <span class="required"></span></label>
          <input matInput [placeholder]="t('sites.fields.siteName')" autocomplete="off" type="text" formControlName="siteName"
            maxlength="100">
        </mat-form-field>
      </div>

      <div class="col-span-full">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="font-normal" for="SiteCode">{{ t('sites.fields.siteCode') }}</label>
          <input matInput [placeholder]="t('sites.fields.siteCode')" autocomplete="off" type="text" formControlName="siteCode"
            maxlength="25">
        </mat-form-field>
      </div>

      <div class="select-input col-span-full md:col-span-1">
        <drdp-select-site-code [initialCodeId]="siteCodeType.value" (code)="onDropDownSelect($event, select.CodeType)"
          [isValid]="!siteCodeType.touched || siteCodeType.valid" [label]="t('sites.fields.siteCodeType')">
        </drdp-select-site-code>
      </div>

      <div class="select-input col-span-full md:col-span-1">
        <drdp-select-type [initialTypeId]="siteType.value" (type)="onDropDownSelect($event, select.SiteType)"
          [required]="true" [isValid]="!siteType.touched || siteType.valid">
        </drdp-select-type>
      </div>

      <div class="col-span-full md:col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="font-normal required" for="siteAddress">{{ t('sites.fields.siteAddress') }}</label>
          <input matInput [placeholder]="t('sites.fields.siteAddress')" autocomplete="off" type="text" formControlName="siteAddress"
            maxlength="100">
        </mat-form-field>
      </div>

      <div class=" col-span-full md:col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="font-normal required" for="siteCity">{{ t('sites.fields.siteCity') }}</label>
          <input matInput [placeholder]="t('sites.fields.siteCity')" autocomplete="off" type="text" formControlName="siteCity"
            maxlength="25">
        </mat-form-field>
      </div>

      @if (viewCountyDropdown) {
        <div class="select-input col-span-full md:col-span-1">
          <drdp-select-county [initialCountyIds]="siteCounty.value" (county)="onDropDownSelect($event, select.County)"
            [stateId]="state.value" [multiSelect]="false" [multiSelectInitVals]="false" [required]="state?.value == states.california"
            [isValid]="!siteCounty.touched || siteCounty.valid" (initCounties)="handleView($event)">
          </drdp-select-county>
        </div>
      }

      <div class="select-input col-span-full md:col-span-1">
        <drdp-select-state (state)="onDropDownSelect($event, select.States)" [clear]="clearDropdowns"
          [initialStateId]="state.value" [required]="true">
        </drdp-select-state>
      </div>

      <div class="col-span-full md:col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="font-normal required" for="SiteZip">{{ t('sites.fields.siteZip') }}</label>
          <input matInput [placeholder]="t('sites.fields.siteZip')" autocomplete="off" type="text" formControlName="siteZip"
            maxlength="10">
        </mat-form-field>
      </div>

      <div class="col-span-full md:col-span-1 mt-3" >
        <div>
          <label class="inline">{{ t('sites.fields.dualEnrollment') }}</label>
          <i class="uil uil-info-circle text-lg ml-2" [matTooltip]="t('sites.fields.dualEnrollmentTooltip')"></i>
        </div>
        <mat-checkbox color="primary" formControlName="isDualEnrollment">
        </mat-checkbox>
      </div>
    </form>

  </div>
  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
    <drdp-btn mat-button [disabled]="siteForm.invalid" cdkFocusInitial (click)="onSubmit()">{{ t('common.save') }}</drdp-btn>

  </div>
</div>
</ng-container>
